import { render, staticRenderFns } from "./SessionObjectCardFreetext.vue?vue&type=template&id=a95d016e&"
import script from "./SessionObjectCardFreetext.vue?vue&type=script&lang=js&"
export * from "./SessionObjectCardFreetext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports